// extracted by mini-css-extract-plugin
export default {"popoverTrigger":"popoverTrigger-E3nu3","value":"value-fEcfl"};